export default __webpack_public_path__ + "static/media/black-panther.b5ecd7a2.jpg";